import { Pipe, PipeTransform } from '@angular/core';
import { GalleryAccessLevel } from '../../lib/access-level';

@Pipe({
  name: 'accessLevel',
  standalone: true,
})
export class AccessLevelPipe implements PipeTransform {
  transform(value: GalleryAccessLevel | 'remove' | 'leave' | 'make-owner'): string {
    if (value === 'edit') return 'Edit';
    if (value === 'review') return 'Review';
    if (value === 'view_only') return 'View';
    if (value === 'no_access') return 'No access';
    if (value === 'remove') return 'Remove';
    if (value === 'leave') return 'Leave';
    if (value === 'make-owner') return 'Make Owner';
  }
}
